/* eslint-disable */
/**
 * AUTO-GENERATED by infrastructure/rbac/generate.mjs from infrastructure/rbac/rbac.json.
 * DO NOT EDIT BY HAND. Edit rbac.json and re-run the generator.
 */

export const RBAC = {
  "version": 5,
  "roles": {
    "auditor": {
      "scope": "tenant",
      "label": "Auditor",
      "description": "Reads the tenant Audit & Compliance Center feed and exports results (non-sensitive values).",
      "permissions": [
        "audit:view",
        "audit:export",
        "expenses:audit"
      ]
    },
    "compliance_officer": {
      "scope": "tenant",
      "label": "Compliance Officer",
      "description": "Full forensic audit access: sensitive values, security events, investigation.",
      "permissions": [
        "audit:view",
        "audit:export",
        "audit:view_sensitive",
        "audit:view_compensation",
        "audit:view_payment",
        "audit:view_payroll",
        "audit:view_security",
        "audit:investigate"
      ]
    },
    "audit_administrator": {
      "scope": "tenant",
      "label": "Audit Administrator",
      "description": "Manages who has audit access. Cannot view audit values or alter history.",
      "permissions": [
        "audit:manage_access"
      ]
    },
    "platform_owner": {
      "scope": "platform",
      "label": "Platform Owner",
      "description": "KaziPeople operator with full control of all tenants, billing, platform settings, and staff.",
      "permissions": [
        "*"
      ]
    },
    "platform_admin": {
      "scope": "platform",
      "label": "Platform Admin",
      "description": "Create/suspend/configure any tenant. No billing management, no platform-staff management, no impersonation.",
      "permissions": [
        "tenant:create",
        "tenant:suspend",
        "tenant:read:all",
        "tenant:update:all",
        "tenant:read:own",
        "tenant:update:own",
        "user:read:all",
        "user:create",
        "user:role:assign",
        "user:mfa:reset",
        "user:deactivate",
        "employee:read",
        "department:read",
        "leavepolicy:read",
        "monitoring:read",
        "analytics:read",
        "auditlog:read:all",
        "feature-flag:manage",
        "product:catalog:read",
        "product:entitlement:manage",
        "ai-config:read",
        "ai-config:write",
        "integration:manage",
        "email:integration:read",
        "compliance:dashboard:view",
        "compliance:retention_policy:view",
        "compliance:retention_policy:create",
        "compliance:retention_policy:update",
        "compliance:legal_hold:view",
        "compliance:legal_hold:create",
        "compliance:legal_hold:release",
        "compliance:erasure_request:view",
        "compliance:erasure_request:create",
        "compliance:erasure_request:review",
        "compliance:erasure_request:approve",
        "compliance:erasure_request:execute_compliance_only",
        "compliance:dry_run:view",
        "compliance:dry_run:run",
        "compliance:audit_evidence:view",
        "compliance:audit_evidence:export",
        "tenant_lifecycle:view",
        "tenant_lifecycle:update",
        "employee_lifecycle:view",
        "employee_lifecycle:update",
        "workforce:marketplace:verify",
        "support:read",
        "support:manage",
        "incident:read",
        "incident:manage",
        "announcement:manage",
        "country_pack:read",
        "country_pack:author",
        "country_pack:publish",
        "benefits:read",
        "benefits:write",
        "benefits:approve",
        "benefits:admin",
        "benefits:payroll_view",
        "credit:read",
        "credit:write",
        "credit:approve",
        "credit:admin",
        "commerce:ops",
        "commerce:ops:resolve",
        "credit:self",
        "migration:read",
        "migration:write",
        "migration:approve",
        "migration:admin",
        "migration:payroll_view",
        "paygate:read",
        "paygate:write",
        "paygate:approve",
        "paygate:admin",
        "paygate:self",
        "performance:self",
        "performance:team",
        "performance:manage",
        "performance:calibrate",
        "performance:compensation",
        "performance:analytics",
        "recognition:create",
        "recognition:read",
        "recognition:manage",
        "recognition:analytics",
        "recognition:configure",
        "compliance:svc_read",
        "compliance:svc_write",
        "compliance:svc_approve",
        "compliance:svc_admin",
        "compliance:svc_payroll_view",
        "holiday_pack:read",
        "holiday_pack:author",
        "holiday_pack:publish",
        "learning:read",
        "learning:manage",
        "learning:assign",
        "support_case:read_tenant",
        "support_case:manage",
        "support_integration:manage",
        "accounting:read"
      ]
    },
    "tax_officer": {
      "scope": "platform",
      "label": "Tax Officer",
      "description": "Authors statutory country packs (PAYE/NSSF/SDL) as drafts for a platform admin to publish. Cannot publish, manage tenants, or access other platform surfaces.",
      "permissions": [
        "country_pack:read",
        "country_pack:author",
        "holiday_pack:read",
        "holiday_pack:author"
      ]
    },
    "platform_support": {
      "scope": "platform",
      "label": "Platform Support",
      "description": "Read across tenants plus limited support writes (reset MFA, impersonate-with-audit).",
      "permissions": [
        "tenant:read:all",
        "user:read:all",
        "user:impersonate",
        "user:mfa:reset",
        "employee:read",
        "monitoring:read",
        "auditlog:read:all",
        "compliance:dashboard:view",
        "compliance:retention_policy:view",
        "compliance:legal_hold:view",
        "compliance:erasure_request:view",
        "compliance:dry_run:view",
        "compliance:audit_evidence:view",
        "tenant_lifecycle:view",
        "employee_lifecycle:view",
        "support:read",
        "support:manage",
        "incident:read",
        "incident:manage",
        "announcement:manage",
        "support_case:read_tenant",
        "support_case:manage"
      ]
    },
    "platform_billing": {
      "scope": "platform",
      "label": "Platform Billing",
      "description": "Subscriptions, usage, and invoices across tenants. No PII writes.",
      "permissions": [
        "tenant:read:all",
        "billing:read:all"
      ]
    },
    "platform_analyst": {
      "scope": "platform",
      "label": "Platform Analyst",
      "description": "Read-only analytics across tenants. No PII writes.",
      "permissions": [
        "tenant:read:all",
        "employee:read",
        "monitoring:read",
        "analytics:read",
        "auditlog:read:all",
        "support:read",
        "incident:read"
      ]
    },
    "tenant_owner": {
      "scope": "tenant",
      "label": "Company Admin",
      "description": "Full control of own company: users, employees, departments, policies, settings, and plan/billing.",
      "permissions": [
        "ai-config:read",
        "ai-config:write",
        "attendance:approve",
        "attendance:connector:read",
        "attendance:import",
        "attendance:read",
        "attendance:write",
        "audit:export",
        "audit:manage_access",
        "audit:view",
        "auditlog:read:own",
        "benefits:admin",
        "benefits:approve",
        "benefits:payroll_view",
        "benefits:read",
        "benefits:write",
        "billing:manage:own",
        "billing:read:own",
        "browser:bookmarks.manage",
        "browser:bookmarks.read",
        "browser:dana.use",
        "browser:external.open",
        "browser:policy.manage",
        "browser:use",
        "compliance:svc_admin",
        "compliance:svc_approve",
        "compliance:svc_payroll_view",
        "compliance:svc_read",
        "compliance:svc_write",
        "credit:admin",
        "commerce:settings",
        "credit:approve",
        "credit:read",
        "credit:self",
        "credit:write",
        "department:read",
        "department:write",
        "email:integration:read",
        "email:integration:write",
        "email:logs:read",
        "email:message:read",
        "email:message:read:content",
        "email:message:reprocess",
        "employee:change:approve",
        "employee:delete",
        "employee:import",
        "employee:payment:approve",
        "employee:payment:read",
        "employee:read",
        "employee:write",
        "expenses:approve",
        "expenses:audit",
        "expenses:create",
        "expenses:export",
        "expenses:finance",
        "expenses:imprest:configure",
        "expenses:policy:manage",
        "expenses:read:all",
        "expenses:read:own",
        "expenses:read:team",
        "expenses:reimburse",
        "expenses:review",
        "holiday:manage",
        "holiday:read",
        "integration:manage",
        "learning:assign",
        "learning:manage",
        "learning:read",
        "leave:approve",
        "leavepolicy:read",
        "leavepolicy:write",
        "migration:admin",
        "migration:approve",
        "migration:payroll_view",
        "migration:read",
        "migration:write",
        "paygate:admin",
        "paygate:approve",
        "paygate:read",
        "paygate:self",
        "paygate:write",
        "payroll:approve",
        "payroll:override_blocker",
        "payroll:read",
        "payroll:write",
        "payroll:details:view",
        "compensation:view",
        "compensation:history:view",
        "compensation:export",
        "payroll:export",
        "payroll:prepare",
        "compensation:edit",
        "payroll:policy:manage",
        "payroll:reject",
        "payroll:lock",
        "payroll:payment:release",
        "payroll:payment:view",
        "performance:analytics",
        "performance:calibrate",
        "performance:compensation",
        "performance:manage",
        "performance:self",
        "performance:team",
        "recognition:analytics",
        "recognition:configure",
        "recognition:create",
        "recognition:manage",
        "recognition:read",
        "reports:create",
        "reports:export",
        "reports:manage_templates",
        "reports:schedule",
        "reports:share",
        "reports:view",
        "support_case:create",
        "support_case:read_self",
        "tenant:read:own",
        "tenant:update:own",
        "user:create",
        "user:deactivate",
        "user:mfa:reset",
        "user:read:own-tenant",
        "user:role:assign",
        "work:approve",
        "work:assign",
        "work:manage",
        "work:remove",
        "work:read",
        "work:view_workload",
        "work:write",
        "workassignment:approve",
        "workassignment:assign",
        "workassignment:manage",
        "workassignment:read",
        "workassignment:write",
        "workforce:comp_impact",
        "workforce:evaluation:approve",
        "workforce:evaluation:lock",
        "workforce:evaluation:read",
        "workforce:evaluation:reopen",
        "workforce:evaluation:score",
        "workforce:framework:assign",
        "workforce:framework:publish",
        "workforce:framework:read",
        "workforce:framework:write",
        "workforce:override",
        "workforce:template:publish",
        "workforce:template:share",
        "accounting:read",
        "accounting:map",
        "accounting:post",
        "attendance:correct",
        "attendance:export",
        "engagement:view",
        "engagement:manage",
        "engagement:approve",
        "commerce:company:purchase",
        "commerce:company:approve",
        "services:booking:manage",
        "services:booking:buy",
        "ba:profile:review"
      ]
    },
    "hr_manager": {
      "scope": "tenant",
      "label": "HR Manager",
      "description": "Org-wide HR AND payroll operations: employees, departments, leave policy, attendance, RUNS payroll (read+write, no approval stage), reviews expenses, manages benefits/lending/payout config, migrations, and workforce frameworks. No billing or company settings.",
      "permissions": [
        "user:read:own-tenant",
        "user:create",
        "employee:read",
        "employee:write",
        "employee:import",
        "department:read",
        "department:write",
        "leavepolicy:read",
        "leavepolicy:write",
        "leave:approve",
        "payroll:read",
        "payroll:write",
        "payroll:details:view",
        "compensation:view",
        "compensation:history:view",
        "compensation:export",
        "payroll:export",
        "payroll:prepare",
        "compensation:edit",
        "payroll:policy:manage",
        "email:integration:read",
        "email:integration:write",
        "email:message:read",
        "email:message:read:content",
        "email:message:reprocess",
        "email:logs:read",
        "attendance:read",
        "attendance:import",
        "attendance:write",
        "attendance:approve",
        "attendance:connector:read",
        "employee:change:approve",
        "employee:payment:read",
        "employee:payment:approve",
        "reports:view",
        "reports:create",
        "reports:export",
        "reports:share",
        "reports:schedule",
        "workforce:framework:read",
        "workforce:framework:write",
        "workforce:framework:publish",
        "workforce:framework:assign",
        "workforce:template:share",
        "workforce:evaluation:read",
        "workforce:evaluation:score",
        "workforce:evaluation:approve",
        "workforce:evaluation:lock",
        "workforce:evaluation:reopen",
        "workforce:override",
        "workforce:comp_impact",
        "workassignment:read",
        "workassignment:write",
        "workassignment:assign",
        "workassignment:approve",
        "workassignment:manage",
        "work:read",
        "work:write",
        "work:assign",
        "work:approve",
        "work:manage",
        "work:remove",
        "work:view_workload",
        "benefits:read",
        "benefits:write",
        "benefits:approve",
        "credit:read",
        "credit:write",
        "credit:admin",
        "migration:read",
        "migration:write",
        "migration:approve",
        "paygate:read",
        "paygate:write",
        "performance:self",
        "performance:team",
        "performance:manage",
        "performance:calibrate",
        "performance:compensation",
        "performance:analytics",
        "recognition:create",
        "recognition:read",
        "recognition:manage",
        "recognition:analytics",
        "recognition:configure",
        "compliance:svc_read",
        "compliance:svc_write",
        "compliance:svc_approve",
        "expenses:read:all",
        "expenses:review",
        "expenses:imprest:configure",
        "holiday:read",
        "holiday:manage",
        "learning:read",
        "learning:manage",
        "learning:assign",
        "support_case:create",
        "support_case:read_self",
        "browser:use",
        "browser:bookmarks.read",
        "browser:bookmarks.manage",
        "browser:external.open",
        "browser:dana.use",
        "browser:policy.manage",
        "attendance:correct",
        "attendance:export",
        "engagement:view",
        "engagement:manage",
        "engagement:approve",
        "services:booking:manage",
        "ba:profile:review"
      ]
    },
    "finance": {
      "scope": "tenant",
      "label": "Finance",
      "description": "Payroll REVIEW and APPROVAL stage plus money movement: approves payroll runs, payouts (paygate) and loans; full expense finance (reimburse/export); attendance and employee-change approval; compensation-impact visibility. Reads employee records and payroll; does not author salaries or HR policy.",
      "permissions": [
        "employee:read",
        "payroll:read",
        "payroll:approve",
        "payroll:details:view",
        "compensation:view",
        "compensation:history:view",
        "compensation:export",
        "payroll:export",
        "payroll:reject",
        "payroll:lock",
        "payroll:payment:release",
        "payroll:payment:view",
        "attendance:read",
        "attendance:approve",
        "employee:change:approve",
        "employee:payment:read",
        "employee:payment:approve",
        "payroll:override_blocker",
        "reports:view",
        "reports:create",
        "reports:export",
        "reports:schedule",
        "workforce:framework:read",
        "workforce:evaluation:read",
        "workforce:comp_impact",
        "workassignment:read",
        "work:read",
        "benefits:read",
        "benefits:payroll_view",
        "credit:read",
        "credit:approve",
        "migration:read",
        "migration:payroll_view",
        "paygate:read",
        "paygate:approve",
        "performance:analytics",
        "recognition:analytics",
        "compliance:svc_read",
        "compliance:svc_payroll_view",
        "expenses:read:all",
        "expenses:finance",
        "expenses:reimburse",
        "expenses:export",
        "expenses:imprest:configure",
        "holiday:read",
        "support_case:create",
        "support_case:read_self",
        "accounting:read",
        "accounting:map",
        "accounting:post",
        "attendance:export",
        "paygate:admin",
        "engagement:view",
        "commerce:company:approve"
      ]
    },
    "hr_staff": {
      "scope": "tenant",
      "label": "HR Staff",
      "description": "Operational HR with broad back-office power: employee records (read+write), payments visibility, reports, benefits approval, lending and payout administration, data migrations, and full performance management incl. calibration. No salary/compensation visibility by default (grant a compensation role explicitly). No leave-policy or company-settings changes.",
      "permissions": [
        "employee:read",
        "employee:write",
        "employee:payment:read",
        "department:read",
        "leavepolicy:read",
        "attendance:read",
        "reports:view",
        "reports:create",
        "reports:export",
        "workassignment:read",
        "work:read",
        "benefits:read",
        "benefits:write",
        "benefits:approve",
        "credit:read",
        "credit:write",
        "credit:admin",
        "migration:read",
        "migration:write",
        "migration:approve",
        "paygate:read",
        "paygate:write",
        "performance:self",
        "performance:team",
        "performance:manage",
        "performance:calibrate",
        "performance:analytics",
        "recognition:create",
        "recognition:read",
        "recognition:manage",
        "recognition:analytics",
        "recognition:configure",
        "compliance:svc_read",
        "compliance:svc_write",
        "compliance:svc_approve",
        "holiday:read",
        "learning:read",
        "learning:manage",
        "learning:assign",
        "support_case:create",
        "support_case:read_self",
        "browser:use",
        "browser:bookmarks.read",
        "browser:bookmarks.manage",
        "browser:external.open",
        "browser:dana.use",
        "browser:policy.manage",
        "attendance:export",
        "attendance:correct",
        "engagement:view",
        "engagement:manage"
      ]
    },
    "manager": {
      "scope": "team",
      "label": "Manager",
      "description": "Team scope: own direct/indirect reports only. Approves leave, attendance, team employee change requests, assignments and team expenses; scores evaluations; team reports and performance. Data is narrowed to reports by the API.",
      "permissions": [
        "employee:read",
        "department:read",
        "leave:approve",
        "employee:change:approve",
        "attendance:read",
        "attendance:approve",
        "reports:view",
        "reports:create",
        "reports:export",
        "workforce:framework:read",
        "workforce:evaluation:read",
        "workforce:evaluation:score",
        "workassignment:read",
        "workassignment:write",
        "workassignment:assign",
        "workassignment:approve",
        "work:read",
        "work:write",
        "work:assign",
        "work:approve",
        "work:view_workload",
        "benefits:read",
        "credit:read",
        "paygate:read",
        "performance:self",
        "performance:team",
        "recognition:create",
        "recognition:read",
        "compliance:svc_read",
        "expenses:create",
        "expenses:read:own",
        "expenses:read:team",
        "expenses:review",
        "expenses:approve",
        "holiday:read",
        "learning:read",
        "learning:assign",
        "support_case:create",
        "support_case:read_self",
        "browser:use",
        "browser:bookmarks.read",
        "browser:external.open",
        "browser:dana.use",
        "attendance:export"
      ]
    },
    "employee": {
      "scope": "self",
      "label": "Employee",
      "description": "Self scope: own profile, leave, payslips, expenses (create/read own), loans, benefits, assignments and self performance. Data is narrowed to self by the API.",
      "permissions": [
        "employee:read",
        "leavepolicy:read",
        "workforce:evaluation:read",
        "workassignment:read",
        "workassignment:write",
        "work:read",
        "work:view_workload",
        "work:write",
        "benefits:read",
        "credit:self",
        "paygate:self",
        "performance:self",
        "recognition:create",
        "recognition:read",
        "compliance:svc_read",
        "expenses:create",
        "expenses:read:own",
        "holiday:read",
        "learning:read",
        "support_case:create",
        "support_case:read_self",
        "browser:use",
        "browser:bookmarks.read",
        "browser:external.open",
        "browser:dana.use"
      ]
    },
    "brand_ambassador": {
      "scope": "self",
      "label": "Brand Ambassador",
      "description": "Self scope, held IN ADDITION to Employee (never instead): the person's own Brand Ambassador portfolio — draft, images, submission and consent — and later their own invitations and events. Never review or publish, other BAs, pay or client data.",
      "permissions": [
        "ba:profile:self"
      ]
    },
    "partner_owner": {
      "scope": "partner",
      "label": "Partner Owner",
      "description": "External lending partner: full control of the partner organisation, including users.",
      "permissions": [
        "partner:read",
        "partner:staff:manage",
        "partner.dashboard.read",
        "partner.products.read",
        "partner.applications.read",
        "partner.applications.decide",
        "partner.loans.read",
        "partner.repayments.read",
        "partner.settlements.read",
        "partner.settlements.manage",
        "partner.reports.read",
        "partner.audit.read",
        "partner.relationships.read",
        "partner.relationships.manage",
        "partner.products.manage",
        "partner.leads.read",
        "partner.leads.write",
        "partner.customers.read",
        "partner.commissions.read",
        "partner.resources.read"
      ]
    },
    "partner_admin": {
      "scope": "partner",
      "label": "Partner Admin",
      "description": "Partner operations lead: manage partner users.",
      "permissions": [
        "partner:read",
        "partner:staff:manage",
        "partner.dashboard.read",
        "partner.products.read",
        "partner.applications.read",
        "partner.applications.decide",
        "partner.loans.read",
        "partner.repayments.read",
        "partner.settlements.read",
        "partner.settlements.manage",
        "partner.reports.read",
        "partner.audit.read",
        "partner.relationships.read",
        "partner.relationships.manage",
        "partner.products.manage",
        "partner.leads.read",
        "partner.leads.write",
        "partner.customers.read",
        "partner.commissions.read",
        "partner.resources.read"
      ]
    },
    "partner_credit_analyst": {
      "scope": "partner",
      "label": "Partner Credit Analyst",
      "description": "Partner underwriting: review and decide loan applications.",
      "permissions": [
        "partner:read",
        "partner.dashboard.read",
        "partner.products.read",
        "partner.applications.read",
        "partner.applications.decide",
        "partner.loans.read",
        "partner.repayments.read",
        "partner.reports.read",
        "partner.relationships.read"
      ]
    },
    "partner_operations": {
      "scope": "partner",
      "label": "Partner Operations",
      "description": "Partner servicing and collections (read-only on the loan book).",
      "permissions": [
        "partner:read",
        "partner.dashboard.read",
        "partner.applications.read",
        "partner.loans.read",
        "partner.repayments.read",
        "partner.reports.read"
      ]
    },
    "partner_finance": {
      "scope": "partner",
      "label": "Partner Finance",
      "description": "Partner reconciliation and settlements.",
      "permissions": [
        "partner:read",
        "partner.dashboard.read",
        "partner.loans.read",
        "partner.repayments.read",
        "partner.settlements.read",
        "partner.settlements.manage",
        "partner.reports.read"
      ]
    },
    "partner_support": {
      "scope": "partner",
      "label": "Partner Support",
      "description": "Partner read-only helpdesk access.",
      "permissions": [
        "partner:read",
        "partner.dashboard.read",
        "partner.applications.read",
        "partner.loans.read",
        "partner.repayments.read"
      ]
    },
    "partner_sales": {
      "scope": "partner",
      "label": "Partner Sales",
      "description": "Partner network sales: register and follow leads, see referred customers and commissions.",
      "permissions": [
        "partner:read",
        "partner.dashboard.read",
        "partner.leads.read",
        "partner.leads.write",
        "partner.customers.read",
        "partner.commissions.read",
        "partner.resources.read",
        "partner.reports.read"
      ]
    },
    "partner_viewer": {
      "scope": "partner",
      "label": "Partner Viewer",
      "description": "Partner read-only access.",
      "permissions": [
        "partner:read",
        "partner.dashboard.read",
        "partner.products.read",
        "partner.applications.read",
        "partner.loans.read",
        "partner.repayments.read",
        "partner.settlements.read",
        "partner.reports.read",
        "partner.relationships.read",
        "partner.leads.read",
        "partner.customers.read",
        "partner.commissions.read",
        "partner.resources.read"
      ]
    }
  },
  "aliases": {
    "super_admin": "platform_owner",
    "system_admin": "platform_admin",
    "system-admin": "platform_admin",
    "tenant_admin": "tenant_owner",
    "tenant-admin": "tenant_owner",
    "admin": "tenant_owner",
    "hr_admin": "hr_manager",
    "hr": "hr_staff"
  },
  "permissions": [
    "tenant:create",
    "tenant:read:all",
    "tenant:update:all",
    "tenant:suspend",
    "tenant:read:own",
    "tenant:update:own",
    "user:create",
    "user:read:all",
    "user:read:own-tenant",
    "user:role:assign",
    "user:mfa:reset",
    "user:deactivate",
    "user:impersonate",
    "employee:read",
    "employee:write",
    "employee:import",
    "employee:delete",
    "department:read",
    "department:write",
    "leavepolicy:read",
    "leavepolicy:write",
    "holiday:read",
    "holiday:manage",
    "holiday_pack:read",
    "holiday_pack:author",
    "holiday_pack:publish",
    "leave:approve",
    "payroll:read",
    "payroll:write",
    "payroll:approve",
    "payroll:details:view",
    "payroll:prepare",
    "payroll:reject",
    "payroll:lock",
    "payroll:export",
    "payroll:payment:release",
    "payroll:payment:view",
    "payroll:policy:manage",
    "compensation:view",
    "compensation:history:view",
    "compensation:edit",
    "compensation:export",
    "engagement:view",
    "engagement:manage",
    "engagement:approve",
    "country_pack:read",
    "country_pack:author",
    "country_pack:publish",
    "billing:read:all",
    "billing:read:own",
    "billing:manage:own",
    "monitoring:read",
    "analytics:read",
    "auditlog:read:all",
    "support:read",
    "support:manage",
    "support_case:create",
    "support_case:read_self",
    "support_case:read_tenant",
    "support_case:manage",
    "support_integration:manage",
    "incident:read",
    "incident:manage",
    "announcement:manage",
    "auditlog:read:own",
    "audit:view",
    "audit:view_sensitive",
    "audit:view_compensation",
    "audit:view_payment",
    "audit:view_payroll",
    "audit:view_security",
    "audit:export",
    "audit:investigate",
    "audit:manage_access",
    "feature-flag:manage",
    "platform-staff:manage",
    "product:catalog:read",
    "product:entitlement:manage",
    "partner:read",
    "partner:staff:manage",
    "partner.dashboard.read",
    "partner.products.read",
    "partner.products.write",
    "partner.products.manage",
    "partner.applications.read",
    "partner.applications.decide",
    "partner.loans.read",
    "partner.repayments.read",
    "partner.settlements.read",
    "partner.settlements.manage",
    "partner.reports.read",
    "partner.relationships.read",
    "partner.relationships.manage",
    "partner.users.read",
    "partner.users.manage",
    "partner.settings.read",
    "partner.settings.manage",
    "partner.audit.read",
    "partner.leads.read",
    "partner.leads.write",
    "partner.customers.read",
    "partner.commissions.read",
    "partner.resources.read",
    "ai-config:read",
    "ai-config:write",
    "integration:manage",
    "email:integration:read",
    "email:integration:write",
    "email:message:read",
    "email:message:read:content",
    "email:message:reprocess",
    "email:logs:read",
    "attendance:read",
    "attendance:import",
    "attendance:write",
    "attendance:correct",
    "attendance:export",
    "attendance:approve",
    "attendance:connector:read",
    "workassignment:read",
    "workassignment:write",
    "workassignment:assign",
    "workassignment:approve",
    "workassignment:manage",
    "work:read",
    "work:write",
    "work:assign",
    "work:approve",
    "work:manage",
    "work:view_workload",
    "work:remove",
    "employee:change:approve",
    "employee:payment:read",
    "employee:payment:approve",
    "payroll:override_blocker",
    "reports:view",
    "reports:create",
    "reports:export",
    "reports:share",
    "reports:manage_templates",
    "reports:schedule",
    "workforce:framework:read",
    "workforce:framework:write",
    "workforce:framework:publish",
    "workforce:framework:assign",
    "workforce:template:share",
    "workforce:evaluation:read",
    "workforce:evaluation:score",
    "workforce:evaluation:approve",
    "workforce:evaluation:lock",
    "workforce:evaluation:reopen",
    "workforce:override",
    "workforce:comp_impact",
    "compliance:dashboard:view",
    "compliance:retention_policy:view",
    "compliance:retention_policy:create",
    "compliance:retention_policy:update",
    "compliance:legal_hold:view",
    "compliance:legal_hold:create",
    "compliance:legal_hold:release",
    "compliance:erasure_request:view",
    "compliance:erasure_request:create",
    "compliance:erasure_request:review",
    "compliance:erasure_request:approve",
    "compliance:erasure_request:execute_compliance_only",
    "compliance:dry_run:view",
    "compliance:dry_run:run",
    "compliance:audit_evidence:view",
    "compliance:audit_evidence:export",
    "tenant_lifecycle:view",
    "tenant_lifecycle:update",
    "employee_lifecycle:view",
    "employee_lifecycle:update",
    "workforce:template:publish",
    "workforce:marketplace:verify",
    "benefits:read",
    "benefits:write",
    "benefits:approve",
    "benefits:admin",
    "benefits:payroll_view",
    "credit:read",
    "credit:write",
    "credit:approve",
    "credit:admin",
    "credit:self",
    "commerce:settings",
    "commerce:ops",
    "commerce:ops:resolve",
    "commerce:company:purchase",
    "commerce:company:approve",
    "services:booking:manage",
    "services:booking:buy",
    "ba:profile:review",
    "ba:profile:self",
    "migration:read",
    "migration:write",
    "migration:approve",
    "migration:admin",
    "migration:payroll_view",
    "accounting:read",
    "accounting:map",
    "accounting:post",
    "paygate:read",
    "paygate:write",
    "paygate:approve",
    "paygate:admin",
    "paygate:self",
    "performance:self",
    "performance:team",
    "performance:manage",
    "performance:calibrate",
    "performance:compensation",
    "performance:analytics",
    "executive.analytics.read",
    "recognition:create",
    "recognition:read",
    "recognition:manage",
    "recognition:analytics",
    "recognition:configure",
    "compliance:svc_read",
    "compliance:svc_write",
    "compliance:svc_approve",
    "compliance:svc_admin",
    "compliance:svc_payroll_view",
    "expenses:create",
    "expenses:read:own",
    "expenses:read:team",
    "expenses:read:all",
    "expenses:review",
    "expenses:approve",
    "expenses:finance",
    "expenses:reimburse",
    "expenses:policy:manage",
    "expenses:imprest:configure",
    "expenses:export",
    "expenses:audit",
    "learning:read",
    "learning:manage",
    "learning:assign",
    "browser:use",
    "browser:bookmarks.read",
    "browser:bookmarks.manage",
    "browser:external.open",
    "browser:dana.use",
    "browser:policy.manage"
  ],
  "permission_meta": {
    "employee:read": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "employee:write": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "attendance:read": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "attendance:write": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "attendance:approve": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "leave:approve": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "employee:change:approve": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "workforce:evaluation:read": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "workforce:evaluation:score": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "workforce:evaluation:approve": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "workassignment:read": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "workassignment:approve": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "workassignment:write": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "workassignment:assign": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "work:read": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "work:approve": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "work:assign": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "work:write": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "work:manage": {
      "scopes": [
        "tenant"
      ]
    },
    "work:view_workload": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "work:remove": {
      "scopes": [
        "tenant"
      ]
    },
    "employee:payment:read": {
      "scopes": [
        "self",
        "tenant"
      ]
    },
    "reports:view": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "performance:self": {
      "scopes": [
        "self"
      ]
    },
    "performance:team": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "performance:manage": {
      "scopes": [
        "tenant"
      ]
    },
    "performance:calibrate": {
      "scopes": [
        "tenant"
      ]
    },
    "performance:compensation": {
      "scopes": [
        "tenant"
      ]
    },
    "performance:analytics": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "executive.analytics.read": {
      "scopes": [
        "tenant"
      ]
    },
    "recognition:create": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "recognition:read": {
      "scopes": [
        "self",
        "team"
      ]
    },
    "recognition:manage": {
      "scopes": [
        "tenant"
      ]
    },
    "recognition:analytics": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "recognition:configure": {
      "scopes": [
        "tenant"
      ]
    },
    "learning:read": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "learning:assign": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "learning:manage": {
      "scopes": [
        "tenant"
      ]
    },
    "support_case:create": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "support_case:read_self": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "support_case:read_tenant": {
      "scopes": [
        "tenant"
      ]
    },
    "support_case:manage": {
      "scopes": [
        "tenant"
      ]
    },
    "browser:use": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "browser:bookmarks.read": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "browser:external.open": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "browser:dana.use": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "browser:bookmarks.manage": {
      "scopes": [
        "tenant"
      ]
    },
    "browser:policy.manage": {
      "scopes": [
        "tenant"
      ]
    },
    "attendance:correct": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "attendance:export": {
      "scopes": [
        "self",
        "team",
        "tenant"
      ]
    },
    "attendance:import": {
      "scopes": [
        "tenant"
      ]
    },
    "attendance:connector:read": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:details:view": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:prepare": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:reject": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:lock": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:export": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:payment:release": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:payment:view": {
      "scopes": [
        "tenant"
      ]
    },
    "payroll:policy:manage": {
      "scopes": [
        "tenant"
      ]
    },
    "compensation:view": {
      "scopes": [
        "self",
        "tenant"
      ]
    },
    "compensation:history:view": {
      "scopes": [
        "tenant"
      ]
    },
    "compensation:edit": {
      "scopes": [
        "tenant"
      ]
    },
    "compensation:export": {
      "scopes": [
        "tenant"
      ]
    },
    "engagement:view": {
      "scopes": [
        "tenant"
      ]
    },
    "engagement:manage": {
      "scopes": [
        "tenant"
      ]
    },
    "engagement:approve": {
      "scopes": [
        "tenant"
      ]
    },
    "expenses:create": {
      "scopes": [
        "self"
      ]
    },
    "expenses:read:own": {
      "scopes": [
        "self"
      ]
    },
    "expenses:read:team": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "expenses:review": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "expenses:approve": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "reports:create": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "reports:export": {
      "scopes": [
        "team",
        "tenant"
      ]
    },
    "credit:self": {
      "scopes": [
        "self"
      ]
    },
    "paygate:self": {
      "scopes": [
        "self"
      ]
    },
    "benefits:read": {
      "scopes": [
        "self"
      ]
    },
    "compliance:svc_read": {
      "scopes": [
        "self"
      ]
    },
    "holiday:read": {
      "scopes": [
        "self",
        "tenant"
      ]
    },
    "leavepolicy:read": {
      "scopes": [
        "self",
        "tenant"
      ]
    },
    "department:read": {
      "scopes": [
        "tenant"
      ]
    },
    "workforce:framework:read": {
      "scopes": [
        "tenant"
      ]
    },
    "credit:read": {
      "scopes": [
        "tenant"
      ]
    },
    "paygate:read": {
      "scopes": [
        "tenant"
      ]
    },
    "ba:profile:self": {
      "scopes": [
        "self"
      ]
    }
  },
  "delegation": {
    "note": "Explicit, deny-by-default delegation catalog. Presence in `permissions` = delegable; sensitivity/duration/reauth/admin-approval resolve permission-override -> category -> defaults.",
    "defaults": {
      "max_duration_days": 30,
      "requires_reauthentication": false,
      "requires_admin_approval": false
    },
    "categories": {
      "people_admin": {
        "label": "People administration",
        "sensitivity": "standard"
      },
      "leave_admin": {
        "label": "Leave administration",
        "sensitivity": "standard"
      },
      "attendance": {
        "label": "Attendance",
        "sensitivity": "standard"
      },
      "employee_changes": {
        "label": "Employee changes & payment methods",
        "sensitivity": "sensitive",
        "requires_reauthentication": true
      },
      "payroll": {
        "label": "Payroll operations",
        "sensitivity": "sensitive",
        "requires_reauthentication": true
      },
      "reports": {
        "label": "Reports",
        "sensitivity": "standard"
      },
      "workassignment": {
        "label": "Work assignments",
        "sensitivity": "standard"
      },
      "work": {
        "label": "Work management",
        "sensitivity": "standard"
      },
      "workforce": {
        "label": "Workforce frameworks",
        "sensitivity": "sensitive"
      },
      "performance": {
        "label": "Performance",
        "sensitivity": "standard"
      },
      "recognition": {
        "label": "Recognition",
        "sensitivity": "standard"
      },
      "benefits": {
        "label": "Benefits",
        "sensitivity": "standard"
      },
      "learning": {
        "label": "Learning",
        "sensitivity": "standard"
      },
      "expenses": {
        "label": "Expenses",
        "sensitivity": "sensitive"
      },
      "commerce": {
        "label": "Company purchases",
        "sensitivity": "sensitive"
      },
      "migration": {
        "label": "Migration & import",
        "sensitivity": "sensitive",
        "requires_reauthentication": true
      },
      "credit": {
        "label": "Credit administration",
        "sensitivity": "sensitive"
      },
      "paygate": {
        "label": "PayGate administration",
        "sensitivity": "sensitive",
        "requires_reauthentication": true
      },
      "compliance": {
        "label": "Compliance operations",
        "sensitivity": "sensitive"
      },
      "holiday": {
        "label": "Holidays",
        "sensitivity": "standard"
      },
      "email": {
        "label": "Email operations",
        "sensitivity": "sensitive",
        "requires_reauthentication": true
      },
      "support": {
        "label": "Support",
        "sensitivity": "standard"
      },
      "user_admin": {
        "label": "User & role administration",
        "sensitivity": "sensitive",
        "requires_reauthentication": true,
        "requires_admin_approval": true
      }
    },
    "permissions": {
      "attendance:approve": {
        "category": "attendance",
        "mode": [
          "approval"
        ]
      },
      "attendance:import": {
        "category": "attendance",
        "mode": [
          "operational"
        ]
      },
      "attendance:read": {
        "category": "attendance",
        "mode": [
          "operational"
        ]
      },
      "attendance:write": {
        "category": "attendance",
        "mode": [
          "operational"
        ]
      },
      "benefits:approve": {
        "category": "benefits",
        "mode": [
          "approval"
        ]
      },
      "benefits:read": {
        "category": "benefits",
        "mode": [
          "operational"
        ]
      },
      "benefits:write": {
        "category": "benefits",
        "mode": [
          "operational"
        ]
      },
      "compliance:erasure_request:approve": {
        "category": "compliance",
        "mode": [
          "approval"
        ]
      },
      "compliance:erasure_request:review": {
        "category": "compliance",
        "mode": [
          "approval"
        ]
      },
      "compliance:svc_approve": {
        "category": "compliance",
        "mode": [
          "approval"
        ]
      },
      "compliance:svc_read": {
        "category": "compliance",
        "mode": [
          "operational"
        ]
      },
      "compliance:svc_write": {
        "category": "compliance",
        "mode": [
          "operational"
        ]
      },
      "credit:admin": {
        "category": "credit",
        "mode": [
          "operational"
        ]
      },
      "credit:approve": {
        "category": "credit",
        "mode": [
          "approval"
        ]
      },
      "credit:read": {
        "category": "credit",
        "mode": [
          "operational"
        ]
      },
      "credit:write": {
        "category": "credit",
        "mode": [
          "operational"
        ]
      },
      "department:read": {
        "category": "people_admin",
        "mode": [
          "operational"
        ]
      },
      "department:write": {
        "category": "people_admin",
        "mode": [
          "operational"
        ]
      },
      "email:integration:read": {
        "category": "email",
        "mode": [
          "operational"
        ]
      },
      "email:integration:write": {
        "category": "email",
        "mode": [
          "operational"
        ]
      },
      "email:logs:read": {
        "category": "email",
        "mode": [
          "operational"
        ]
      },
      "email:message:read": {
        "category": "email",
        "mode": [
          "operational"
        ]
      },
      "email:message:read:content": {
        "category": "email",
        "mode": [
          "operational"
        ],
        "sensitivity": "sensitive"
      },
      "email:message:reprocess": {
        "category": "email",
        "mode": [
          "operational"
        ]
      },
      "employee:change:approve": {
        "category": "employee_changes",
        "mode": [
          "approval"
        ]
      },
      "engagement:approve": {
        "category": "employee_changes",
        "mode": [
          "approval"
        ]
      },
      "employee:import": {
        "category": "people_admin",
        "mode": [
          "operational"
        ]
      },
      "employee:payment:approve": {
        "category": "employee_changes",
        "mode": [
          "approval"
        ]
      },
      "employee:payment:read": {
        "category": "employee_changes",
        "mode": [
          "operational"
        ]
      },
      "employee:read": {
        "category": "people_admin",
        "mode": [
          "operational"
        ]
      },
      "employee:write": {
        "category": "people_admin",
        "mode": [
          "operational"
        ]
      },
      "expenses:approve": {
        "category": "expenses",
        "mode": [
          "approval"
        ]
      },
      "expenses:read:all": {
        "category": "expenses",
        "mode": [
          "operational"
        ]
      },
      "expenses:review": {
        "category": "expenses",
        "mode": [
          "approval"
        ]
      },
      "holiday:manage": {
        "category": "holiday",
        "mode": [
          "operational"
        ]
      },
      "holiday:read": {
        "category": "holiday",
        "mode": [
          "operational"
        ]
      },
      "learning:assign": {
        "category": "learning",
        "mode": [
          "approval"
        ]
      },
      "learning:manage": {
        "category": "learning",
        "mode": [
          "operational"
        ]
      },
      "learning:read": {
        "category": "learning",
        "mode": [
          "operational"
        ]
      },
      "leave:approve": {
        "category": "leave_admin",
        "mode": [
          "approval"
        ]
      },
      "leavepolicy:read": {
        "category": "leave_admin",
        "mode": [
          "operational"
        ]
      },
      "leavepolicy:write": {
        "category": "leave_admin",
        "mode": [
          "operational"
        ]
      },
      "migration:approve": {
        "category": "migration",
        "mode": [
          "approval"
        ]
      },
      "migration:read": {
        "category": "migration",
        "mode": [
          "operational"
        ]
      },
      "migration:write": {
        "category": "migration",
        "mode": [
          "operational"
        ]
      },
      "paygate:admin": {
        "category": "paygate",
        "mode": [
          "operational"
        ]
      },
      "paygate:approve": {
        "category": "paygate",
        "mode": [
          "approval"
        ]
      },
      "commerce:company:approve": {
        "category": "commerce",
        "mode": [
          "approval"
        ]
      },
      "ba:profile:review": {
        "category": "people_admin",
        "mode": [
          "approval"
        ]
      },
      "paygate:read": {
        "category": "paygate",
        "mode": [
          "operational"
        ]
      },
      "paygate:write": {
        "category": "paygate",
        "mode": [
          "operational"
        ]
      },
      "payroll:approve": {
        "category": "payroll",
        "mode": [
          "approval"
        ]
      },
      "payroll:read": {
        "category": "payroll",
        "mode": [
          "operational"
        ]
      },
      "payroll:write": {
        "category": "payroll",
        "mode": [
          "operational"
        ]
      },
      "performance:analytics": {
        "category": "performance",
        "mode": [
          "operational"
        ]
      },
      "performance:calibrate": {
        "category": "performance",
        "mode": [
          "approval"
        ]
      },
      "performance:compensation": {
        "category": "performance",
        "mode": [
          "operational"
        ]
      },
      "performance:manage": {
        "category": "performance",
        "mode": [
          "operational"
        ]
      },
      "performance:team": {
        "category": "performance",
        "mode": [
          "operational"
        ]
      },
      "recognition:analytics": {
        "category": "recognition",
        "mode": [
          "operational"
        ]
      },
      "recognition:configure": {
        "category": "recognition",
        "mode": [
          "operational"
        ]
      },
      "recognition:create": {
        "category": "recognition",
        "mode": [
          "operational"
        ]
      },
      "recognition:manage": {
        "category": "recognition",
        "mode": [
          "operational"
        ]
      },
      "recognition:read": {
        "category": "recognition",
        "mode": [
          "operational"
        ]
      },
      "reports:create": {
        "category": "reports",
        "mode": [
          "operational"
        ]
      },
      "reports:export": {
        "category": "reports",
        "mode": [
          "operational"
        ]
      },
      "reports:schedule": {
        "category": "reports",
        "mode": [
          "operational"
        ]
      },
      "reports:share": {
        "category": "reports",
        "mode": [
          "operational"
        ]
      },
      "reports:view": {
        "category": "reports",
        "mode": [
          "operational"
        ]
      },
      "support_case:create": {
        "category": "support",
        "mode": [
          "operational"
        ]
      },
      "support_case:read_self": {
        "category": "support",
        "mode": [
          "operational"
        ]
      },
      "user:create": {
        "category": "people_admin",
        "mode": [
          "operational"
        ]
      },
      "user:read:own-tenant": {
        "category": "people_admin",
        "mode": [
          "operational"
        ]
      },
      "user:role:assign": {
        "category": "user_admin",
        "mode": [
          "approval"
        ]
      },
      "work:approve": {
        "category": "work",
        "mode": [
          "approval"
        ]
      },
      "work:assign": {
        "category": "work",
        "mode": [
          "approval"
        ]
      },
      "work:manage": {
        "category": "work",
        "mode": [
          "operational"
        ]
      },
      "work:read": {
        "category": "work",
        "mode": [
          "operational"
        ]
      },
      "work:write": {
        "category": "work",
        "mode": [
          "operational"
        ]
      },
      "workassignment:approve": {
        "category": "workassignment",
        "mode": [
          "approval"
        ]
      },
      "workassignment:assign": {
        "category": "workassignment",
        "mode": [
          "approval"
        ]
      },
      "workassignment:manage": {
        "category": "workassignment",
        "mode": [
          "operational"
        ]
      },
      "workassignment:read": {
        "category": "workassignment",
        "mode": [
          "operational"
        ]
      },
      "workassignment:write": {
        "category": "workassignment",
        "mode": [
          "operational"
        ]
      },
      "workforce:comp_impact": {
        "category": "workforce",
        "mode": [
          "operational"
        ]
      },
      "workforce:evaluation:approve": {
        "category": "workforce",
        "mode": [
          "approval"
        ]
      },
      "workforce:evaluation:read": {
        "category": "workforce",
        "mode": [
          "operational"
        ]
      },
      "workforce:evaluation:score": {
        "category": "workforce",
        "mode": [
          "operational"
        ]
      },
      "workforce:framework:assign": {
        "category": "workforce",
        "mode": [
          "approval"
        ]
      },
      "workforce:framework:publish": {
        "category": "workforce",
        "mode": [
          "approval"
        ]
      },
      "workforce:framework:read": {
        "category": "workforce",
        "mode": [
          "operational"
        ]
      },
      "workforce:framework:write": {
        "category": "workforce",
        "mode": [
          "operational"
        ]
      },
      "workforce:override": {
        "category": "workforce",
        "mode": [
          "approval"
        ]
      },
      "workforce:template:publish": {
        "category": "workforce",
        "mode": [
          "operational"
        ]
      }
    }
  }
} as const;

export type Role = 'auditor' | 'compliance_officer' | 'audit_administrator' | 'platform_owner' | 'platform_admin' | 'tax_officer' | 'platform_support' | 'platform_billing' | 'platform_analyst' | 'tenant_owner' | 'hr_manager' | 'finance' | 'hr_staff' | 'manager' | 'employee' | 'brand_ambassador' | 'partner_owner' | 'partner_admin' | 'partner_credit_analyst' | 'partner_operations' | 'partner_finance' | 'partner_support' | 'partner_sales' | 'partner_viewer';
export type Permission = 'tenant:create' | 'tenant:read:all' | 'tenant:update:all' | 'tenant:suspend' | 'tenant:read:own' | 'tenant:update:own' | 'user:create' | 'user:read:all' | 'user:read:own-tenant' | 'user:role:assign' | 'user:mfa:reset' | 'user:deactivate' | 'user:impersonate' | 'employee:read' | 'employee:write' | 'employee:import' | 'employee:delete' | 'department:read' | 'department:write' | 'leavepolicy:read' | 'leavepolicy:write' | 'holiday:read' | 'holiday:manage' | 'holiday_pack:read' | 'holiday_pack:author' | 'holiday_pack:publish' | 'leave:approve' | 'payroll:read' | 'payroll:write' | 'payroll:approve' | 'payroll:details:view' | 'payroll:prepare' | 'payroll:reject' | 'payroll:lock' | 'payroll:export' | 'payroll:payment:release' | 'payroll:payment:view' | 'payroll:policy:manage' | 'compensation:view' | 'compensation:history:view' | 'compensation:edit' | 'compensation:export' | 'engagement:view' | 'engagement:manage' | 'engagement:approve' | 'country_pack:read' | 'country_pack:author' | 'country_pack:publish' | 'billing:read:all' | 'billing:read:own' | 'billing:manage:own' | 'monitoring:read' | 'analytics:read' | 'auditlog:read:all' | 'support:read' | 'support:manage' | 'support_case:create' | 'support_case:read_self' | 'support_case:read_tenant' | 'support_case:manage' | 'support_integration:manage' | 'incident:read' | 'incident:manage' | 'announcement:manage' | 'auditlog:read:own' | 'audit:view' | 'audit:view_sensitive' | 'audit:view_compensation' | 'audit:view_payment' | 'audit:view_payroll' | 'audit:view_security' | 'audit:export' | 'audit:investigate' | 'audit:manage_access' | 'feature-flag:manage' | 'platform-staff:manage' | 'product:catalog:read' | 'product:entitlement:manage' | 'partner:read' | 'partner:staff:manage' | 'partner.dashboard.read' | 'partner.products.read' | 'partner.products.write' | 'partner.products.manage' | 'partner.applications.read' | 'partner.applications.decide' | 'partner.loans.read' | 'partner.repayments.read' | 'partner.settlements.read' | 'partner.settlements.manage' | 'partner.reports.read' | 'partner.relationships.read' | 'partner.relationships.manage' | 'partner.users.read' | 'partner.users.manage' | 'partner.settings.read' | 'partner.settings.manage' | 'partner.audit.read' | 'partner.leads.read' | 'partner.leads.write' | 'partner.customers.read' | 'partner.commissions.read' | 'partner.resources.read' | 'ai-config:read' | 'ai-config:write' | 'integration:manage' | 'email:integration:read' | 'email:integration:write' | 'email:message:read' | 'email:message:read:content' | 'email:message:reprocess' | 'email:logs:read' | 'attendance:read' | 'attendance:import' | 'attendance:write' | 'attendance:correct' | 'attendance:export' | 'attendance:approve' | 'attendance:connector:read' | 'workassignment:read' | 'workassignment:write' | 'workassignment:assign' | 'workassignment:approve' | 'workassignment:manage' | 'work:read' | 'work:write' | 'work:assign' | 'work:approve' | 'work:manage' | 'work:view_workload' | 'work:remove' | 'employee:change:approve' | 'employee:payment:read' | 'employee:payment:approve' | 'payroll:override_blocker' | 'reports:view' | 'reports:create' | 'reports:export' | 'reports:share' | 'reports:manage_templates' | 'reports:schedule' | 'workforce:framework:read' | 'workforce:framework:write' | 'workforce:framework:publish' | 'workforce:framework:assign' | 'workforce:template:share' | 'workforce:evaluation:read' | 'workforce:evaluation:score' | 'workforce:evaluation:approve' | 'workforce:evaluation:lock' | 'workforce:evaluation:reopen' | 'workforce:override' | 'workforce:comp_impact' | 'compliance:dashboard:view' | 'compliance:retention_policy:view' | 'compliance:retention_policy:create' | 'compliance:retention_policy:update' | 'compliance:legal_hold:view' | 'compliance:legal_hold:create' | 'compliance:legal_hold:release' | 'compliance:erasure_request:view' | 'compliance:erasure_request:create' | 'compliance:erasure_request:review' | 'compliance:erasure_request:approve' | 'compliance:erasure_request:execute_compliance_only' | 'compliance:dry_run:view' | 'compliance:dry_run:run' | 'compliance:audit_evidence:view' | 'compliance:audit_evidence:export' | 'tenant_lifecycle:view' | 'tenant_lifecycle:update' | 'employee_lifecycle:view' | 'employee_lifecycle:update' | 'workforce:template:publish' | 'workforce:marketplace:verify' | 'benefits:read' | 'benefits:write' | 'benefits:approve' | 'benefits:admin' | 'benefits:payroll_view' | 'credit:read' | 'credit:write' | 'credit:approve' | 'credit:admin' | 'credit:self' | 'commerce:settings' | 'commerce:ops' | 'commerce:ops:resolve' | 'commerce:company:purchase' | 'commerce:company:approve' | 'services:booking:manage' | 'services:booking:buy' | 'ba:profile:review' | 'ba:profile:self' | 'migration:read' | 'migration:write' | 'migration:approve' | 'migration:admin' | 'migration:payroll_view' | 'accounting:read' | 'accounting:map' | 'accounting:post' | 'paygate:read' | 'paygate:write' | 'paygate:approve' | 'paygate:admin' | 'paygate:self' | 'performance:self' | 'performance:team' | 'performance:manage' | 'performance:calibrate' | 'performance:compensation' | 'performance:analytics' | 'executive.analytics.read' | 'recognition:create' | 'recognition:read' | 'recognition:manage' | 'recognition:analytics' | 'recognition:configure' | 'compliance:svc_read' | 'compliance:svc_write' | 'compliance:svc_approve' | 'compliance:svc_admin' | 'compliance:svc_payroll_view' | 'expenses:create' | 'expenses:read:own' | 'expenses:read:team' | 'expenses:read:all' | 'expenses:review' | 'expenses:approve' | 'expenses:finance' | 'expenses:reimburse' | 'expenses:policy:manage' | 'expenses:imprest:configure' | 'expenses:export' | 'expenses:audit' | 'learning:read' | 'learning:manage' | 'learning:assign' | 'browser:use' | 'browser:bookmarks.read' | 'browser:bookmarks.manage' | 'browser:external.open' | 'browser:dana.use' | 'browser:policy.manage';
export type Scope = 'platform' | 'partner' | 'tenant' | 'team' | 'self';

const ALIASES = RBAC.aliases as unknown as Record<string, string>;
const ROLE_DEFS = RBAC.roles as unknown as Record<string, { scope: Scope; permissions: string[] }>;

/** Map a legacy/alias role name to its canonical name. */
export function normalizeRole(role: string): string {
  return ALIASES[role] ?? role;
}

export function normalizeRoles(roles: string[] | null | undefined): string[] {
  return Array.from(new Set((roles ?? []).map(normalizeRole)));
}

/** The data scope a role operates in. */
export function roleScope(role: string): Scope {
  const r = ROLE_DEFS[normalizeRole(role)];
  return r ? r.scope : 'self';
}

/** Token-level scope by highest-privilege role: 'platform' > 'partner' > 'tenant'. */
export function tokenScope(roles: string[] | null | undefined): 'platform' | 'partner' | 'tenant' {
  const rs = normalizeRoles(roles);
  if (rs.some((r) => roleScope(r) === 'platform')) return 'platform';
  if (rs.some((r) => roleScope(r) === 'partner')) return 'partner';
  return 'tenant';
}

/** Resolve the union of permissions for a set of roles. '*' means all. */
export function permissionsForRoles(roles: string[] | null | undefined): string[] {
  const out = new Set<string>();
  for (const role of normalizeRoles(roles)) {
    const def = ROLE_DEFS[role];
    if (!def) continue;
    for (const p of def.permissions) {
      if (p === '*') return ['*'];
      out.add(p);
    }
  }
  return Array.from(out);
}

export function hasPermission(roles: string[] | null | undefined, permission: string): boolean {
  const perms = permissionsForRoles(roles);
  return perms.includes('*') || perms.includes(permission);
}

// ---- Per-permission grant scopes (authz-hardening Phase 3) ----------------
// A grant scope is the DATA reach of one permission: self < team < tenant.
// platform/partner roles collapse to 'tenant' here — plane separation stays on
// tokenScope; grants only answer "which subjects within my plane".

export type GrantScope = 'self' | 'direct_reports' | 'team' | 'tenant';
// direct_reports (immediate reports only) sits just below team (recursive subtree)
// on the rank ladder — a narrowing, never a widening.
export const GRANT_RANK: Record<string, number> = { self: 0, direct_reports: 0.5, team: 1, tenant: 2, partner: 2, platform: 2 };
const PERMISSION_META = RBAC.permission_meta as unknown as Record<string, { scopes: string[] }>;

// ---- Delegation policy (role/permission delegation) ------------------------
// The canonical, deny-by-default catalog of delegable permissions. A permission is
// delegable ONLY if it appears in RBAC.delegation.permissions; its policy resolves
// permission-override -> category -> defaults. This replaces the old action-name regex.
export type DelegationMode = 'approval' | 'operational';
export type DelegationSensitivity = 'standard' | 'sensitive';
export interface DelegationPolicy {
  delegable: boolean;
  category: string;
  categoryLabel: string;
  mode: DelegationMode[];
  sensitivity: DelegationSensitivity;
  maxDurationDays: number;
  requiresReauthentication: boolean;
  requiresAdminApproval: boolean;
}
const DELEGATION = RBAC.delegation as unknown as {
  defaults: { max_duration_days?: number; requires_reauthentication?: boolean; requires_admin_approval?: boolean };
  categories: Record<string, { label: string; sensitivity: DelegationSensitivity; requires_reauthentication?: boolean; requires_admin_approval?: boolean; max_duration_days?: number }>;
  permissions: Record<string, { category: string; mode: DelegationMode[]; sensitivity?: DelegationSensitivity; requires_reauthentication?: boolean; requires_admin_approval?: boolean; max_duration_days?: number }>;
};

/** Whether a permission may be delegated at all (deny-by-default). */
export function isDelegable(permission: string): boolean {
  return Object.prototype.hasOwnProperty.call(DELEGATION.permissions, permission);
}

/** Resolved delegation policy for a permission, or null if it is not delegable.
 *  Layered: permission override -> category -> catalog defaults. */
export function delegationPolicy(permission: string): DelegationPolicy | null {
  const p = DELEGATION.permissions[permission];
  if (!p) return null;
  const c = DELEGATION.categories[p.category] ?? { label: p.category, sensitivity: 'standard' as DelegationSensitivity };
  const d = DELEGATION.defaults ?? {};
  const pick = <T>(...vals: (T | undefined)[]): T | undefined => vals.find((v) => v !== undefined);
  return {
    delegable: true,
    category: p.category,
    categoryLabel: c.label ?? p.category,
    mode: p.mode ?? ['operational'],
    sensitivity: pick(p.sensitivity, c.sensitivity, 'standard') as DelegationSensitivity,
    maxDurationDays: pick(p.max_duration_days, c.max_duration_days, d.max_duration_days, 30) as number,
    requiresReauthentication: pick(p.requires_reauthentication, c.requires_reauthentication, d.requires_reauthentication, false) as boolean,
    requiresAdminApproval: pick(p.requires_admin_approval, c.requires_admin_approval, d.requires_admin_approval, false) as boolean,
  };
}

/** The full delegable catalog grouped by category — for building the delegation UI.
 *  Each entry carries the resolved policy; only currently-delegable permissions appear. */
export function delegationCatalog(): { category: string; label: string; sensitivity: DelegationSensitivity; permissions: Array<{ key: string } & DelegationPolicy> }[] {
  const byCat: Record<string, Array<{ key: string } & DelegationPolicy>> = {};
  for (const key of Object.keys(DELEGATION.permissions)) {
    const pol = delegationPolicy(key)!;
    (byCat[pol.category] ??= []).push({ key, ...pol });
  }
  return Object.keys(byCat)
    .sort()
    .map((category) => {
      const cat = DELEGATION.categories[category] ?? { label: category, sensitivity: 'standard' as DelegationSensitivity };
      return { category, label: cat.label ?? category, sensitivity: (cat.sensitivity ?? 'standard') as DelegationSensitivity, permissions: byCat[category] ?? [] };
    });
}

/** The allowed grant scopes for a permission (["tenant"] when scope-meaningless). */
export function allowedScopesFor(permission: string): GrantScope[] {
  const m = PERMISSION_META[permission];
  return (m?.scopes as GrantScope[] | undefined) ?? ['tenant'];
}

/**
 * Clamp a role's scope onto the permission's allowed scopes: the smallest
 * allowed scope whose rank is >= the role's (never narrows below what the
 * permission can express; falls back to the widest allowed).
 */
export function effectiveScopeFor(permission: string, roleOrEdgeScope: string): GrantScope {
  // direct_reports is a NARROWING of team (immediate reports only). Honour it only
  // where team-level reach is allowed; it must NEVER auto-upgrade to team. Where a
  // permission cannot express team, fall back to the widest it can (self, else the
  // permission's own ceiling) — never widening.
  if (roleOrEdgeScope === 'direct_reports') {
    const allowed = allowedScopesFor(permission);
    if (allowed.includes('team')) return 'direct_reports';
    if (allowed.includes('self')) return 'self';
    return allowed[allowed.length - 1] ?? 'tenant';
  }
  const rank = GRANT_RANK[roleOrEdgeScope] ?? 2;
  const allowed = allowedScopesFor(permission)
    .slice()
    .sort((a, b) => (GRANT_RANK[a] ?? 2) - (GRANT_RANK[b] ?? 2));
  for (const s of allowed) if ((GRANT_RANK[s] ?? 2) >= rank) return s;
  return allowed[allowed.length - 1] ?? 'tenant';
}

/**
 * Per-permission effective grant scope for a role set: for each permission the
 * HIGHEST scope across the roles granting it. A wildcard role returns
 * {'*': 'tenant'} (all permissions at full-plane reach).
 */
export function grantsForRoles(roles: string[] | null | undefined): Record<string, GrantScope> {
  const out: Record<string, GrantScope> = {};
  for (const role of normalizeRoles(roles)) {
    const def = ROLE_DEFS[role];
    if (!def) continue;
    for (const p of def.permissions) {
      if (p === '*') return { '*': 'tenant' };
      const s = effectiveScopeFor(p, def.scope);
      const cur = out[p];
      if (!cur || (GRANT_RANK[s] ?? 2) > (GRANT_RANK[cur] ?? 2)) out[p] = s;
    }
  }
  return out;
}

/** The effective grant scope this role set holds for one permission (null = not granted). */
export function scopeForPermission(
  roles: string[] | null | undefined,
  permission: string,
): GrantScope | null {
  const grants = grantsForRoles(roles);
  if (grants['*']) return 'tenant';
  return grants[permission] ?? null;
}

// ---- Shared scope resolver (org-scope Phase B) ----------------------------
// The single-sourced "which scope" decision. Downstream services previously
// re-derived scope from roles alone (scopeForPermission), which cannot see
// custom-role or tenant scope-policy overrides — those live in the token
// `grants` claim. resolveDataScope consumes the claim so every service (and
// Dana/MCP) reaches the SAME decision. The POPULATION (which employee ids a
// scope expands to) is owned by employee-service, not this binding.

// A DataScope is the resolved reach for one permission: the rank ladder
// (self < team < tenant) PLUS lateral population scopes (org-scope Phase C:
// `department`, `branch`; multi-entity Phase 2: `legal_entity`) that are NOT
// on that ladder — the gate resolves their member set from employee-service.
// Lateral scopes with no resolver yet stay clamped to a rank scope at mint time
// (auth clampScopeDown), so they never reach here.
//
// `legal_entity` differs from the others in where its population comes from.
// department and branch are derived from the caller's OWN employee record;
// legal_entity is an explicit GRANT (auth.entity_grants), because employment is
// not authority — Group HR administers several entities while being employed by
// one. See docs/architecture/MULTI_ENTITY_ORGANIZATIONS.md §5.
export type DataScope = 'self' | 'direct_reports' | 'team' | 'tenant' | 'department' | 'branch' | 'legal_entity';
const VALID_DATA_SCOPES: Record<string, true> = { self: true, direct_reports: true, team: true, tenant: true, department: true, branch: true, legal_entity: true };

/**
 * Reconstitute the FULL per-permission grants map from a role-derived floor and
 * a token `grants` claim DELTA. The claim is AUTHORITATIVE — auth already folded
 * roles + custom-role scopes + tenant policy into it — so a claim entry REPLACES
 * the floor for that permission. (A rank-MAX would silently drop a *narrowing*
 * policy and cannot carry a lateral scope.) {'*':'tenant'} on either side wins;
 * values outside the vocabulary are ignored.
 */
export function mergeGrants(
  base: Record<string, DataScope>,
  claim: Record<string, DataScope> | null | undefined,
): Record<string, DataScope> {
  if (base['*']) return { '*': 'tenant' };
  const out: Record<string, DataScope> = { ...base };
  if (claim && typeof claim === 'object') {
    if ((claim as Record<string, unknown>)['*']) return { '*': 'tenant' };
    for (const [p, s] of Object.entries(claim)) {
      if (!VALID_DATA_SCOPES[s as string]) continue;
      out[p] = s;
    }
  }
  return out;
}

/**
 * The AUTHORITATIVE data scope a caller holds for one permission. Unions the
 * token `grants` claim (delta) with the role floor, so custom-role AND tenant
 * scope-policy overrides are honored. May return a lateral scope (`department`),
 * whose population the gate resolves from employee-service. Returns null when the
 * permission is scope-meaningless / not granted (caller treats as tenant-or-deny).
 */
export function resolveDataScope(
  roles: string[] | null | undefined,
  grantsClaim: Record<string, DataScope> | null | undefined,
  permission: string,
): DataScope | null {
  const full = mergeGrants(grantsForRoles(normalizeRoles(roles)), grantsClaim);
  if (full['*']) return 'tenant';
  return full[permission] ?? null;
}
